<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center">
        <v-col md="12" lg="12" sm="12" class="px-0">
          <v-btn
            fab
            x-small
            class="mx-2 mb-2"
            color="white"
            @click="$router.back()"
          >
            <v-icon light> mdi-arrow-left </v-icon>
          </v-btn>
          <!-- Main Container -->
          <v-card class="mt-4" rounded="xl" color="blue lighten-5" width="auto">
            <!-- Dashboard Container -->
            <v-container fluid>
              <v-row class="pt-4">
                <v-col>
                  <v-toolbar-title class="text-h4 blue--text">
                    Attendances
                  </v-toolbar-title>
                </v-col>
              </v-row>

              <!-- Category Cards -->
              <v-row class="pb-5 mx-1" no-gutters>
                <!-- Count Cards: 2 per row on small screens (sm="6"), full width on extra small (cols="12") -->
                <v-col cols="12" sm="6" md="4" lg="2" class="count-card">
                  <v-card class="pa-4 ma-2" rounded="lg" elevation="2">
                    <v-card-title class="text-h6">Sites</v-card-title>
                    <v-card-text class="text-h4 blue--text">{{
                      totalSites
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2" class="count-card">
                  <v-card class="pa-4 ma-2" rounded="lg" elevation="2">
                    <v-card-title class="text-h6">Manpower</v-card-title>
                    <v-card-text class="text-h4 blue--text">{{
                      totalManpower
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2" class="count-card">
                  <v-card class="pa-4 ma-2" rounded="lg" elevation="2">
                    <v-card-title class="text-h6">Present</v-card-title>
                    <v-card-text class="text-h4 blue--text">{{
                      present
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2" class="count-card">
                  <v-card class="pa-4 ma-2" rounded="lg" elevation="2">
                    <v-card-title class="text-h6">Absent</v-card-title>
                    <v-card-text class="text-h4 blue--text">{{
                      absent
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2" class="count-card">
                  <v-card class="pa-4 ma-2" rounded="lg" elevation="2">
                    <v-card-title class="text-h6">Reliever</v-card-title>
                    <v-card-text class="text-h4 blue--text">{{
                      reliever
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2" class="count-card">
                  <v-card class="pa-4 ma-2" rounded="lg" elevation="2">
                    <v-card-title class="text-h6">Shortage</v-card-title>
                    <v-card-text class="text-h4 blue--text">{{
                      shortage
                    }}</v-card-text>
                  </v-card>
                </v-col>
                <!-- Navigation Cards -->
                <v-col cols="12" sm="6" md="6">
                  <v-card
                    class="pa-4 ma-2"
                    rounded="lg"
                    elevation="2"
                    @click="navigateTo('/master/attendances/operation-team')"
                  >
                    <v-card-title class="text-h6"
                      >Operation Team Backend</v-card-title
                    >
                    <v-card-text>View backend team details</v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-card
                    class="pa-4 ma-2"
                    rounded="lg"
                    elevation="2"
                    @click="navigateTo('/attendances')"
                  >
                    <v-card-title class="text-h6"
                      >Sites Attendance</v-card-title
                    >
                    <v-card-text>View site attendance details</v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="footer-text">
      <v-row justify="center">
        <v-col align="center">
          <h3 class="white--text">We Alliance Sparkle</h3>
          <h4 class="white--text">v 1.0.0</h4>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      totalSites: 0,
      totalManpower: 0,
      present: 0,
      absent: 0,
      reliever: 0,
      shortage: 0,
    };
  },
  async mounted() {
    this.getData();
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    async getData() {
      let masterAttendance = await axios.get(`/getMasterAttendanceDashboard`);
      this.masterAttendance = masterAttendance.data.data;
      this.totalSites = this.masterAttendance.total_site;
      this.totalManpower = this.masterAttendance.total_man_power;
      this.present = this.masterAttendance.total_present;
      this.absent = this.masterAttendance.total_absent;
      this.reliever = this.masterAttendance.total_reliever;
      this.shortage = this.masterAttendance.total_shortage;
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .count-card {
    flex: 0 0 50% !important;
    max-width: 50% !important;
  }
}
</style>
